import { useEffect, useState } from 'react'

/**
 * Aviso fijo mientras el equipo no tiene red.
 *
 * Instalada como aplicacion, el sistema abre aunque no haya internet: el
 * service worker guarda la pantalla, no los datos. Sin este aviso el cajero
 * veria la aplicacion "normal" y recien se enteraria al fallar el cobro.
 *
 * `navigator.onLine` solo sabe si el equipo tiene red, no si el servidor
 * responde: un wifi sin salida a internet cuenta como conectado. Ese caso lo
 * cubren los mensajes de error de cada llamada a la API. Esto es para el caso
 * mas comun y mas facil de explicar: se cayo el wifi.
 */
export function AvisoConexion() {
    const [enLinea, setEnLinea] = useState(() => navigator.onLine)

    useEffect(() => {
        const alConectar = () => setEnLinea(true)
        const alDesconectar = () => setEnLinea(false)

        window.addEventListener('online', alConectar)
        window.addEventListener('offline', alDesconectar)

        return () => {
            window.removeEventListener('online', alConectar)
            window.removeEventListener('offline', alDesconectar)
        }
    }, [])

    if (enLinea) return null

    return (
        <div className="aviso aviso-atencion" role="status" style={{ marginBottom: 'var(--e3)' }}>
            <strong>Sin conexión.</strong> No se puede vender ni cobrar hasta que vuelva la
            red: lo que ve en pantalla puede no estar al día.
        </div>
    )
}
